import React, { useEffect, useState } from "react";
import axios from "axios";
import { testUrl } from "./BaseData";
import { useTranslation } from "react-i18next";
import classes from "./HomeGallery.module.css";
import AOS from "aos";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export const HomeGallery = () => {
    const [images, setImages] = useState([]);
    const { i18n } = useTranslation();

    useEffect(() => {
        axios.get(testUrl + "/api/home-gallery/")
            .then(res => setImages(res.data))
            .catch(err => console.error(err));

        AOS.init({ duration: 1000 });
    }, []);

    if (images.length === 0) return null;

    return (
        <section className={classes.gallerySection}>
            <Swiper
                modules={[Pagination, Autoplay, Navigation]}
                spaceBetween={0}
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                className={classes.swiperContainer}
                loop={images.length > 1}
            >
                {images.map((item) => (
                    <SwiperSlide key={item.id}>
                        <div className={classes.galleryItem}>
                            <img src={item.image} alt={item[`title_${i18n.language}`] || ""} />
                            {(item[`title_${i18n.language}`] || item.title_uz) && (
                                <div className={classes.overlay}>
                                    <h3>{item[`title_${i18n.language}`] || item.title_uz}</h3>
                                </div>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

